import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';


import {RouteadminguardGuard} from './security/routeadminguard.guard';
import {HelpsMainComponent} from './views/adminview/helps/helps-main/helps-main.component';
import {HelpsListComponent} from './views/adminview/helps/helps-list/helps-list.component';
import {HelpsEditComponent} from './views/adminview/helps/helps-edit/helps-edit.component';
import {NewsMainComponent} from './views/adminview/news/news-main/news-main.component';
import {NewsEditComponent} from './views/adminview/news/news-edit/news-edit.component';
import {NewsListComponent} from './views/adminview/news/news-list/news-list.component';
import {MandantMainComponent} from './views/adminview/mandant/mandant-main/mandant-main.component';
import {MandantListComponent} from './views/adminview/mandant/mandant-list/mandant-list.component';
import {MandantEditComponent} from './views/adminview/mandant/mandant-edit/mandant-edit.component';
import {ToolsMainComponent} from './views/adminview/tools/tools-main/tools-main.component';
import {ToolsListComponent} from './views/adminview/tools/tools-list/tools-list.component';
import {ToolsEditComponent} from './views/adminview/tools/tools-edit/tools-edit.component';

import {MainviewComponent} from './views/mainview/mainview.component';
import {ToolviewComponent} from './views/toolview/toolview.component';
import {RouteguardGuard} from './security/routeguard.guard';
import {AdminviewComponent} from './views/adminview/adminview.component';
import {HelpviewComponent} from './views/helpview/helpview.component';
import {RoutehomeguardGuard} from './security/routehomeguard.guard';
import {MainLandingComponent} from './views/components/main-landing/main-landing.component';
import {RoleMainComponent} from './views/adminview/role/role-main/role-main.component';
import {RoleListComponent} from './views/adminview/role/role-list/role-list.component';
import {RoleEditComponent} from './views/adminview/role/role-edit/role-edit.component';
import {LanguageMainComponent} from './views/adminview/language/language-main/language-main.component';
import {LanguageListComponent} from './views/adminview/language/language-list/language-list.component';
import {LanguageEditComponent} from './views/adminview/language/language-edit/language-edit.component';

import {AttributeMainComponent} from './views/adminview/attribute-groupe/attribute-main/attribute-main.component';
import {AttributeListComponent} from './views/adminview/attribute-groupe/attribute-list/attribute-list.component';
import {AttributeEditComponent} from './views/adminview/attribute-groupe/attribute-edit/attribute-edit.component';
import {AttributeTypeMainComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-main/attribute-type-main.component';
import {AttributeTypeListComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-list/attribute-type-list.component';
import {AttributeTypeEditComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-edit/attribute-type-edit.component';
import {UsersMainComponent} from './views/adminview/users/users-main/users-main.component';
import {UsersListComponent} from './views/adminview/users/users-list/users-list.component';

import {DashboardComponent} from './views/adminview/dashboard/dashboard.component';

import {LogsMainComponent} from './views/adminview/logs/logs-main/logs-main.component';
import {LogsListComponent} from './views/adminview/logs/logs-list/logs-list.component';
import {LogsDetailsComponent} from './views/adminview/logs/logs-details/logs-details.component';

import {UserprofilviewComponent} from './views/userprofilview/userprofil-view/userprofilview.component';
import {UserprofilEditComponent} from './views/userprofilview/userprofil-edit/userprofil-edit.component';
import {UserprofilMainComponent} from './views/userprofilview/userprofil-main/userprofil-main.component';

import {OrderviewComponent} from './views/orderview/orderview.component';

import {UsersToolsListComponent} from './views/adminview/users/users-tools-list/users-tools-list.component';
import {UsersToolsEditComponent} from './views/adminview/users/users-tools-edit/users-tools-edit.component';
import {UsersToolMainComponent} from './views/adminview/users/users-tool-main/users-tool-main.component';

import {AosOrdersComponent} from './views/orderview/aos-orders/aos-orders.component';
import {WebshopOrdersComponent} from './views/orderview/webshop-orders/webshop-orders.component';
import {TranslationMainComponent} from './views/adminview/translation/translation-main/translation-main.component';
import {TranslationListComponent} from './views/adminview/translation/translation-list/translation-list.component';
import {TranslationEditComponent} from './views/adminview/translation/translation-edit/translation-edit.component';
import {TranslationAddCsvComponent} from './views/adminview/translation/translation-add-csv/translation-add-csv.component';
import {PasswordforgotviewComponent} from './views/passwordforgotview/passwordforgotview.component';
import {PasswordresetviewComponent} from './views/passwordresetview/passwordresetview.component';
import {CompaniesMainComponent} from './views/adminview/companies/companies-main/companies-main.component';
import {CompaniesListComponent} from './views/adminview/companies/companies-list/companies-list.component';
import {CompaniesEditComponent} from './views/adminview/companies/companies-edit/companies-edit.component';
import {DosOrdersComponent} from './views/orderview/dos-orders/dos-orders.component';
import {UsersEditComponent} from './views/adminview/users/users-edit/users-edit.component';
import {BusinessCardOrdersComponent} from './views/orderview/business-card-orders/business-card-orders.component';
import {MarketsMainComponent} from './views/adminview/markets/markets-main/markets-main.component';
import {MarketsListComponent} from './views/adminview/markets/markets-list/markets-list.component';
import {MarketsEditComponent} from './views/adminview/markets/markets-edit/markets-edit.component';
import {MarketgroupsMainComponent} from './views/adminview/marketgroups/marketgroups-main/marketgroups-main.component';
import {MarketgroupsListComponent} from './views/adminview/marketgroups/marketgroups-list/marketgroups-list.component';
import {MarketgroupsEditComponent} from './views/adminview/marketgroups/marketgroups-edit/marketgroups-edit.component';
import {FlagcategoriesMainComponent} from '@views/adminview/flagcategories/flagcategories-main/flagcategories-main.component';
import {FlagcategoriesListComponent} from '@views/adminview/flagcategories/flagcategories-list/flagcategories-list.component';
import {FlagcategoriesEditComponent} from '@views/adminview/flagcategories/flagcategories-edit/flagcategories-edit.component';
import {FlagsMainComponent} from '@views/adminview/flags/flags-main/flags-main.component';
import {FlagsListComponent} from '@views/adminview/flags/flags-list/flags-list.component';
import {FlagsEditComponent} from '@views/adminview/flags/flags-edit/flags-edit.component';
import {UploadsMainComponent} from '@views/adminview/uploads/uploads-main/uploads-main.component';
import {UploadsListComponent} from '@views/adminview/uploads/uploads-list/uploads-list.component';
import {UploadsEditComponent} from '@views/adminview/uploads/uploads-edit/uploads-edit.component';
import {CompaniesUsersComponent} from '@views/adminview/companies/companies-users/companies-users.component';
import {AppdomainMainComponent} from '@views/adminview/appdomain/appdomain-main/appdomain-main.component';
import {AppdomainEditComponent} from '@views/adminview/appdomain/appdomain-edit/appdomain-edit.component';
import {AppdomainListComponent} from '@views/adminview/appdomain/appdomain-list/appdomain-list.component';
import {UnblockUserViewComponent} from '@views/unblockuserview/unblock-user-view.component';
import {PagenotfoundComponent} from "@views/pagenotfound/pagenotfound.component";
import {ToollistviewComponent} from '@views/toollistview/toollistview.component';
import {PackshotVideoLonginesOrdersComponent} from '@views/orderview/packshot-video-longines/packshot-video-longines-orders.component';


const routes: Routes = [
  {
    path: '',
    component: MainviewComponent,
    children: [
      {
        path: '',
        component: MainLandingComponent,
        canActivate: [RoutehomeguardGuard],
      },
      {
        path: 'password/forgot',
        component: PasswordforgotviewComponent,
        canActivate: [RoutehomeguardGuard]
      },
      {
        path: 'password/reset/:token/:userId',
        component: PasswordresetviewComponent,
        canActivate: [RoutehomeguardGuard]
      },
      {
        path: 'users/unblock/:token',
        component: UnblockUserViewComponent,
        canActivate: [RoutehomeguardGuard]
      },
      {
        path: 'profil',
        component: UserprofilMainComponent,
        canActivate: [RoutehomeguardGuard],
        children: [
          {
            path: '',
            component: UserprofilviewComponent,
            canActivate: [RouteadminguardGuard]
          },
          {
            path: ':id/edit',
            component: UserprofilEditComponent,
            canActivate: [RouteadminguardGuard]
          },
        ]
      },
      {
        path: 'admin',
        component: AdminviewComponent,
        children: [
          {
            path: '',
            component: DashboardComponent,
            canActivate: [RouteadminguardGuard]
          },
          {
            path: 'helps',
            component: HelpsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: HelpsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: HelpsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: HelpsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'companies',
            component: CompaniesMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: CompaniesListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: CompaniesEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create/:parentid',
                component: CompaniesEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: CompaniesEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/users',
                component: CompaniesUsersComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'logs',
            component: LogsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: LogsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id',
                component: LogsDetailsComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'news',
            component: NewsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: NewsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: NewsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: NewsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'mandant',
            component: MandantMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: MandantListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: MandantEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: MandantEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'appdomains',
            component: AppdomainMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: AppdomainListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: AppdomainEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: AppdomainEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'tools',
            component: ToolsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: ToolsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: ToolsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: ToolsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'roles',
            component: RoleMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: RoleListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: RoleEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: RoleEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'users',
            component: UsersMainComponent,
            canActivate: [RouteadminguardGuard],
            runGuardsAndResolvers: 'always',
            children: [
              {
                path: '',
                component: UsersListComponent,
                canActivate: [RouteadminguardGuard],
                runGuardsAndResolvers: 'always',
              },
              {
                path: 'create',
                component: UsersEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: UsersEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/usertoolconfigs',
                component: UsersToolMainComponent,
                canActivate: [RouteadminguardGuard],
                children: [
                  {
                    path: '',
                    component: UsersToolsListComponent,
                    canActivate: [RouteadminguardGuard],
                  },
                  {
                    path: ':id/edit',
                    component: UsersToolsEditComponent,
                    canActivate: [RouteadminguardGuard],
                  }
                ]
              },
              // {
              //   path: ':id/edit/tools',
              //   component: UsersToolMainComponent,
              //   canActivate: [RouteadminguardGuard],
              //   children: [
              //     {
              //       path: '',
              //       component: UsersToolsListComponent,
              //       canActivate: [RouteadminguardGuard],
              //     },
              //     {
              //       path: ':toolid/create',
              //       component: UsersToolsEditComponent,
              //       canActivate: [RouteadminguardGuard],
              //     },
              //     {
              //       path: ':toolid/edit',
              //       component: UsersToolsEditComponent,
              //       canActivate: [RouteadminguardGuard],
              //     },
              //   ]
              // }
            ]
          },
          {
            path: 'languages',
            component: LanguageMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: LanguageListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: LanguageEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: LanguageEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'attributes',
            component: AttributeMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: AttributeListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: AttributeEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: AttributeEditComponent,
                canActivate: [RouteadminguardGuard],
                children: [
                  {
                    path: '',
                    component: AttributeTypeMainComponent,
                    canActivate: [RouteadminguardGuard],
                    children: [
                      {
                        path: '',
                        component: AttributeTypeListComponent,
                        canActivate: [RouteadminguardGuard],
                      },
                      {
                        path: 'create',
                        component: AttributeTypeEditComponent,
                        canActivate: [RouteadminguardGuard],
                      },
                      {
                        path: ':id/edit',
                        component: AttributeTypeEditComponent,
                        canActivate: [RouteadminguardGuard],
                      },
                    ]
                  },
                ]
              },
              {
                path: 'attributes-type',
                component: AttributeTypeMainComponent,
                canActivate: [RouteadminguardGuard],
                children: [
                  {
                    path: '',
                    component: AttributeTypeListComponent,
                    canActivate: [RouteadminguardGuard],
                  },
                  {
                    path: 'create',
                    component: AttributeTypeEditComponent,
                    canActivate: [RouteadminguardGuard],
                  },
                  {
                    path: ':id/edit',
                    component: AttributeTypeEditComponent,
                    canActivate: [RouteadminguardGuard],
                  },
                ]
              },
            ]
          },
          {
            path: 'translation',
            component: TranslationMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: TranslationListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: TranslationEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create-many',
                component: TranslationAddCsvComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: TranslationEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'markets',
            component: MarketsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: MarketsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: MarketsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: MarketsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'marketgroups',
            component: MarketgroupsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: MarketgroupsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: MarketgroupsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: MarketgroupsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'flagcategories',
            component: FlagcategoriesMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: FlagcategoriesListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: FlagcategoriesEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: FlagcategoriesEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'flags',
            component: FlagsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: FlagsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: FlagsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: FlagsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
          {
            path: 'uploads',
            component: UploadsMainComponent,
            canActivate: [RouteadminguardGuard],
            children: [
              {
                path: '',
                component: UploadsListComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: 'create',
                component: UploadsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
              {
                path: ':id/edit',
                component: UploadsEditComponent,
                canActivate: [RouteadminguardGuard],
              },
            ]
          },
        ]
      },
      // {
      //   path: 'admin/:module',
      //   component: AdminviewComponent,
      //   canActivate: [RouteguardGuard],
      // },
      {
        path: 'tools',
        component: ToollistviewComponent,
        canActivate: [RouteguardGuard],
      },
      {
        path: 'orders',
        component: OrderviewComponent,
        canActivate: [RouteguardGuard],
        children: [
          {
            path: '',
            redirectTo: 'aos',
            pathMatch: 'full'
          },
          {
            path: 'aos',
            component: AosOrdersComponent,
            canActivate: [RouteguardGuard]
          },
          {
            path: 'dos',
            component: DosOrdersComponent,
            canActivate: [RouteguardGuard]
          },
          {
            path: 'webshop',
            component: WebshopOrdersComponent,
            canActivate: [RouteguardGuard]
          },
          {
            path: 'business-cards',
            component: BusinessCardOrdersComponent,
            canActivate: [RouteguardGuard]
          },
          {
            path: 'packshot-video-longines',
            component: PackshotVideoLonginesOrdersComponent,
            canActivate: [RouteguardGuard]
          }
        ]
      },
      {
        path: ':languagekey/help',
        component: HelpviewComponent,
        canActivate: [RouteguardGuard],
      },
      {
        path: ':languagekey/ext/:toolid/:toolkey/:params',
        component: ToolviewComponent,
        canActivate: [RouteguardGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: ':languagekey/ext/:toolid/:toolkey',
        component: ToolviewComponent,
        canActivate: [RouteguardGuard],
        runGuardsAndResolvers: 'always'
      },
    ]
  },
  {
    path: '404',
    component: PagenotfoundComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
